import React, { useState } from "react";
import PropTypes from "prop-types";

import { getDryRun, setDryRun, isDryRunActive } from "../dryRun";
import "../css/SourceSwitch.css";

/*
 * Sélecteur de source de données de l'écran /dispatch — OUTIL DE DEV uniquement (masqué au build de
 * prod). Bascule l'écran natif sur local / preprod / réplica prod (lecture seule via tunnel), sans
 * rien écrire. En prod, ce composant ne rend rien : l'API travaille sur sa propre base directement.
 */
const DEV = process.env.NODE_ENV !== "production";
const SOURCES = [
  { value: "local", label: "Local (deleev-db)" },
  { value: "preprod", label: "Preprod" },
  { value: "prod", label: "Réplica prod (live)" },
];

export function SourceSwitch({ onReload }) {
  const [source, setSource] = useState(getDryRun().source);
  const [day, setDay] = useState(getDryRun().day);

  if (!DEV) { return null; }

  const apply = () => {
    setDryRun({ source, day });
    if (onReload) { onReload(); }
  };

  return (
    <div className={`SourceSwitch${isDryRunActive() ? " SourceSwitch--active" : ""}`}>
      <span className="SourceSwitch-tag">dev</span>
      <label>
        Source
        <select value={source} onChange={(e) => setSource(e.target.value)}>
          {SOURCES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
      </label>
      <label>
        Jour
        <input type="date" value={day} onChange={(e) => setDay(e.target.value)} />
      </label>
      <button className="SourceSwitch-apply" onClick={apply}>Appliquer</button>
    </div>
  );
}

SourceSwitch.propTypes = {
  onReload: PropTypes.func,
};
